define((require) => {
    "use strict";

    const $                             = require("jquery");
    const AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView");
    const ColorPicker                   = require("shared/services/ColorPicker");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                      = require("ui/experience/widgets/lineWidget/LineWidgetPropertiesView.tpl");
    const AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    const EXPAND_PROPERTY = "lineExpanded";

    /**
     * The properties view for a line widget.
     *
     * @class LineWidgetPropertiesView
     * @constructor
     *
     * @cfg {LineWidgetModel} model The model for the line widget being edited.
     */
    return AbstractWidgetPropertiesView.extend({
        expandProperty: EXPAND_PROPERTY,

        template: template,

        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".line-properties-container\"]",
            lineProperties: ".line-properties-container",
            lineBackgroundColorInput: ".line-background-color-input",
            lineBackgroundColorBox: ".line-background-color-box",
            lineWeightInput: ".line-weight",
            lineWeightOptions: ".line-weight-options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        events: {
            "click .line-weight-options a": "_clickedLineWeightOptions",
            "change .line-background-color-input": "_lineBackgroundColorInput"
        },

        _clickedLineWeightOptions(event) {
            event.preventDefault();
            this.ui.lineWeightInput.val(event.target.getAttribute("data-weight")).trigger("change");
            this.ui.lineWeightOptions.find("a").removeClass("selected");
            $(event.target).addClass("selected");
            this.model.set("lineHeight", event.target.getAttribute("data-weight"));
        },

        _lineBackgroundColorInput(event) {
            this.model.set("lineColor", event.currentTarget.value);
        },

        _setStrokeWeightSelection(weight) {
            this.ui.lineWeightOptions.find(`[data-weight="${weight}"]`).addClass("selected");
        },

        onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model, hideSizeControls: true, showLineControls: true, widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("lineColor"),
                input: this.ui.lineBackgroundColorInput,
                colorBox: this.ui.lineBackgroundColorBox
            });

            this.ui.lineBackgroundColorInput.val(this.model.get("lineColor"));
            this._setStrokeWeightSelection(this.model.get("lineHeight"));
        },

        onClose() {
            this._backgroundColorPicker.dispose();
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/lineWidget/LineWidgetPropertiesView.js